export default {
      id: "oc-user-del-usage",
      viewBox: "0 0 1047 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-user-del",
      toString: function () {
        return this.url;
      }
    }